import styled from 'styled-components';

const BannerWrapper = styled.div`
  width: 100%;
  border-bottom: 10px solid #4b0082;
  img: {
    width: '50%'
  }
`;

export default BannerWrapper